import { always } from "asrt";
import { isInstanceOf } from "@pzapalski/ts-utils/dist/guards/is-instance-of";
export function enableWhenLoaded(element) {
    always(isInstanceOf(HTMLInputElement, element), "[aJJ-EFC-hEb]");
    element.disabled = false;
}
